"use strict";
var _a, _b, _c, _d, _e;
window.addEventListener("load", function () {
    setTimeout(function () {
        document.querySelector(".fbt-location").style.opacity = "1";
    }, 1000);
});
(_a = document.querySelector('.back-buttons button')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
    window.history.back();
});
// @ts-ignore
var primarySplide = new Splide(document.querySelector(".product-thumbnails-splide"), {
    perPage: 1,
    perMove: 1,
    type: 'slide',
    gap: "5px",
    pagination: true,
    arrows: true,
}).mount();
document.querySelectorAll('.splide__slide model-viewer').forEach(function (model) {
    model.addEventListener('pointerdown', function (e) {
        primarySplide.options = { drag: false };
        e.stopPropagation();
    });
    model.addEventListener('touchstart', function (e) {
        primarySplide.options = { drag: false };
        e.stopPropagation();
    });
    model.addEventListener('mousedown', function (e) {
        primarySplide.options = { drag: false };
        e.stopPropagation();
    });
    ['pointerup', 'pointercancel', 'mouseleave'].forEach(function (eventName) {
        model.addEventListener(eventName, function () {
            primarySplide.options = { drag: true };
        });
    });
});
document.querySelectorAll('.nav-item').forEach(function (navItem) {
    navItem.addEventListener('click', function () {
        var index = parseInt(navItem.getAttribute('data-index') || "0") - 1;
        var isActive = navItem.classList.contains('active-item');
        if (isActive && !navItem.classList.contains('model-item')) {
            // @ts-ignore
            var lightboxGallery = fsLightboxInstances["gallery"];
            if (lightboxGallery && lightboxGallery.open) {
                var index_1 = parseInt(navItem.getAttribute('data-index') || "0") - 1;
                lightboxGallery.open(index_1);
            }
        }
        else {
            primarySplide.go(index);
        }
        document.querySelectorAll('.nav-item').forEach(function (item) {
            item.classList.remove('active-item');
        });
        navItem.classList.add('active-item');
    });
});
function waitForElmSPP(selector) {
    // @ts-ignore
    return new Promise(function (resolve) {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        var observer = new MutationObserver(function (mutations) {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}
var quantityControllers = document.querySelectorAll('.single-product .quantity-controller button');
if (quantityControllers && quantityControllers.length) {
    quantityControllers.forEach(function (quantityController) {
        quantityController.addEventListener('click', function () {
            var _a;
            var input = (_a = quantityController.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector('input');
            if (input) {
                var currentValue = parseInt(input.value);
                var max = parseInt(input.getAttribute('max') || "0");
                if (quantityController.classList.contains('up') && (currentValue + 1) <= max) {
                    input.value = (currentValue + 1).toString();
                    changePriceByMultiple(input.value);
                }
                else if (quantityController.classList.contains('down') && (currentValue - 1) > 0) {
                    input.value = (currentValue - 1).toString();
                    changePriceByMultiple(input.value);
                }
                handleFreeShippingBadge();
            }
        });
    });
}
function handleFreeShippingBadge() {
    var _a, _b, _c;
    var input = getActiveQuantitySelectorInput();
    if (input) {
        var inputValue = input.value;
        var selectedVariantPrice = ((_a = document.querySelector('.single-product .focus-block .price')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-price')) || "";
        if (selectedVariantPrice) {
            var price = parseInt(selectedVariantPrice);
            var qty = parseInt(inputValue || "1");
            if ((price * qty) >= 80000) {
                (_b = document.querySelector(".product-page-badges .badge.free-ship")) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
            }
            else {
                (_c = document.querySelector(".product-page-badges .badge.free-ship")) === null || _c === void 0 ? void 0 : _c.classList.add('d-none');
            }
        }
    }
}
function changePriceByMultiple(multiple) {
    var priceElements = document.querySelectorAll('.single-product .focus-block .price, .single-product .floated-focus-block .price');
    for (var index = 0; index < priceElements.length; index++) {
        var priceElement = priceElements[index];
        var priceSpanElement = priceElement.querySelector('span');
        if (priceElement && priceSpanElement) {
            var originalPrice = priceElement.getAttribute('data-price') || "0";
            var originalComparePrice = priceSpanElement.getAttribute('data-compare-price') || "0";
            if (originalPrice && originalComparePrice) {
                var newPrice = (parseFloat(originalPrice) * parseInt(multiple)) / 100;
                var newComparePrice = (parseFloat(originalComparePrice) * parseInt(multiple)) / 100;
                var newPriceCurrency = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'ZAR'
                }).format(newPrice);
                var newComparePriceCurrency = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'ZAR'
                }).format(newComparePrice);
                handleSavingsDisplay(newPrice.toString(), newComparePrice.toString());
                priceElement.outerHTML = "<p class=\"price\" data-price=\"".concat(originalPrice, "\">R").concat(newPriceCurrency.replace("ZAR", ""), " <span class=\"compare-price\" data-compare-price=\"").concat(originalComparePrice, "\">R").concat(newComparePriceCurrency.replace("ZAR", ""), "</span></p>");
            }
        }
    }
}
var wishlistButtons = document.querySelectorAll('.add-to-wishlist');
wishlistButtons.forEach(function (button) {
    button.addEventListener('click', function () {
        var _a, _b;
        var productId = button.getAttribute('data-product-id');
        var customerId = button.getAttribute('data-customer-id');
        var wishlistAddUrl = "https://ccd-typescript-api-5341184e38bc.herokuapp.com/wishlist/add/".concat(customerId, "/").concat(productId);
        (_a = button.querySelector(".loading-spinner")) === null || _a === void 0 ? void 0 : _a.classList.remove('d-none');
        (_b = button.querySelector(".heart")) === null || _b === void 0 ? void 0 : _b.classList.add('d-none');
        fetch(wishlistAddUrl, {
            method: "POST",
        }).then(function () {
            var _a, _b;
            (_a = button.querySelector(".loading-spinner")) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
            (_b = button.querySelector(".tick")) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
            setTimeout(function () {
                var _a, _b;
                (_a = button.querySelector(".heart")) === null || _a === void 0 ? void 0 : _a.classList.remove('d-none');
                (_b = button.querySelector(".tick")) === null || _b === void 0 ? void 0 : _b.classList.add('d-none');
            }, 1000);
        });
    });
});
var promptWishlistButtons = document.querySelectorAll('.prompt-wishlist');
promptWishlistButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
        var _a, _b;
        (_b = (_a = button.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector('.popover')) === null || _b === void 0 ? void 0 : _b.classList.toggle('d-none');
        event.stopPropagation();
    });
});
document.addEventListener('click', function (event) {
    promptWishlistButtons.forEach(function (button) {
        var _a;
        var popover = (_a = button.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector('.popover');
        if (!(popover === null || popover === void 0 ? void 0 : popover.contains(event.target)) && event.target !== button) {
            popover === null || popover === void 0 ? void 0 : popover.classList.add('d-none');
        }
    });
});
var popovers = document.querySelectorAll('.popover');
popovers.forEach(function (popover) {
    popover.addEventListener('click', function (event) {
        event.stopPropagation();
    });
});
function handleVariantChange(element) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    document.querySelectorAll('.single-product .focus-block .variants button').forEach(function (singleItem) {
        singleItem.classList.remove('active');
    });
    element.classList.add('active');
    var id = element.getAttribute('id') || "";
    var price = element.getAttribute("data-variant-price") || "";
    var comparePrice = element.getAttribute("data-variant-compare-price") || "";
    var quantity = parseInt(element.getAttribute("data-quantity") || "0");
    var trackedInv = element.getAttribute("data-variant-inventory_management");
    var mediaId = element.getAttribute("data-variant-media-id");
    var checkQuantity = trackedInv === "shopify";
    if (checkQuantity) {
        if (quantity == 0) {
            // Hide quantity selector, add to cart & wishlist
            var element_1 = document.createElement('div');
            element_1.innerHTML = "\n        <form class=\"back-in-stock-form\">\n          <p class=\"d-flex align-items-center\">\n            <img src=\"https://cdn.shopify.com/s/files/1/0505/3071/3798/files/time.svg?v=1694178330\" alt=\"Sold out icon\">\n            <span>Sold out! Awaiting stock. Get notified.</span>    \n          </p>\n          <input type=\"email\" name=\"email\" placeholder=\"Email Address*\" required autocomplete=\"off\">\n          <input type=\"text\" name=\"name\" placeholder=\"Your Name (Optional)\" autocomplete=\"off\">\n          <label><input type=\"checkbox\" name=\"subscribe\">Subscribe to our mailing list</label>\n          <label><input type=\"checkbox\" name=\"smsSubscribe\" onclick=\"handleSmsSubscribe(this)\">Receive exclusive offers via SMS</label>\n          <br>\n          <div class=\"phone-number-wrapper d-none\">\n              <input type=\"tel\" name=\"phone\" placeholder=\"Phone Number (Optional)\" autocomplete=\"off\">\n              <br>\n          </div>\n          <button class=\"block-btn red\" type=\"submit\">Notify Me</button>\n        </form>\n      ";
            var singleProduct_1 = document.querySelector('.single-product');
            (_a = document.querySelector(".single-product .focus-block .back-in-stock-form")) === null || _a === void 0 ? void 0 : _a.replaceWith(element_1);
            var newForm = document.querySelector(".single-product .focus-block .back-in-stock-form");
            if (newForm && singleProduct_1) {
                setupBackInStockForm(newForm, singleProduct_1);
            }
            (_b = document.querySelector(".single-product .focus-block .add-to-cart-wrapper")) === null || _b === void 0 ? void 0 : _b.classList.add('d-none');
            (_c = document.querySelector(".single-product .focus-block .quantity-selector")) === null || _c === void 0 ? void 0 : _c.classList.add('d-none');
        }
        else {
            if (document.querySelector(".single-product .focus-block .back-in-stock-form")) {
                (_d = document.querySelector(".single-product .focus-block .back-in-stock-form")) === null || _d === void 0 ? void 0 : _d.classList.add('d-none');
            }
            (_e = document.querySelector(".single-product .focus-block .add-to-cart-wrapper")) === null || _e === void 0 ? void 0 : _e.classList.remove('d-none');
            (_f = document.querySelector(".single-product .focus-block .quantity-selector")) === null || _f === void 0 ? void 0 : _f.classList.remove('d-none');
        }
    }
    else {
        if (document.querySelector(".single-product .focus-block .back-in-stock-form")) {
            (_g = document.querySelector(".single-product .focus-block .back-in-stock-form")) === null || _g === void 0 ? void 0 : _g.classList.add('d-none');
        }
        (_h = document.querySelector(".single-product .focus-block .add-to-cart-wrapper")) === null || _h === void 0 ? void 0 : _h.classList.remove('d-none');
        (_j = document.querySelector(".single-product .focus-block .quantity-selector")) === null || _j === void 0 ? void 0 : _j.classList.remove('d-none');
    }
    if (comparePrice) {
        handleSavingsDisplay(price, comparePrice);
    }
    else {
        (_k = document.querySelector('.single-product .focus-block .savings-badge')) === null || _k === void 0 ? void 0 : _k.classList.add('d-none');
    }
    var priceElement = document.querySelector('.single-product .focus-block .price');
    var priceInt = parseRandToCents(price);
    var comparePriceInt = parseRandToCents(comparePrice);
    priceElement.setAttribute('data-price', priceInt.toString());
    priceElement.innerHTML = "".concat(price.trim(), " ").concat((comparePrice) ? "<span class=\"compare-price\" data-compare-price=\"".concat(comparePriceInt, "\">").concat(comparePrice.trim(), "</span>") : "");
    var floatedPriceElement = document.querySelector('.single-product .floated-focus-block .price');
    if (floatedPriceElement) {
        floatedPriceElement.setAttribute('data-price', priceInt.toString());
        floatedPriceElement.innerHTML = "".concat(price.trim(), " ").concat((comparePrice) ? "<span class=\"compare-price\" data-compare-price=\"".concat(comparePriceInt, "\">").concat(comparePrice.trim(), "</span>") : "");
    }
    var maxQuantity = quantity;
    if (trackedInv != "shopify") {
        maxQuantity = 999;
    }
    var input = getActiveQuantitySelectorInput();
    if (input) {
        input.value = "1";
        input.setAttribute('max', maxQuantity.toString());
        changePriceByMultiple("1");
    }
    var addToCarts = document.querySelectorAll('.single-product .focus-block .add-to-cart, .single-product .floated-focus-block .add-to-cart');
    addToCarts.forEach(function (addToCart) {
        var _a, _b, _c, _d;
        var _e, _f;
        addToCart.setAttribute('data-id', id);
        var addToCartButtonClasses = "add-to-cart d-flex align-items-center justify-content-center flex-1";
        var soldOutButtonClasses = "sold-out";
        if (quantity === 0 && checkQuantity != false) {
            addToCart.setAttribute('disabled', "true");
            (_a = addToCart.classList).remove.apply(_a, addToCartButtonClasses.split(" "));
            (_b = addToCart.classList).add.apply(_b, soldOutButtonClasses.split(" "));
            addToCart.querySelector("span").textContent = "Sold out";
            (_e = addToCart.querySelector(".plus")) === null || _e === void 0 ? void 0 : _e.classList.add('d-none');
        }
        else {
            addToCart.removeAttribute('disabled');
            (_c = addToCart.classList).remove.apply(_c, soldOutButtonClasses.split(" "));
            (_d = addToCart.classList).add.apply(_d, addToCartButtonClasses.split(" "));
            addToCart.querySelector("span").textContent = "Add to Cart";
            (_f = addToCart.querySelector(".plus")) === null || _f === void 0 ? void 0 : _f.classList.remove('d-none');
        }
    });
    if (mediaId) {
        var thumbnailImage = document.querySelector('.single-product-thumbnails .nav-item[data-media-id="' + mediaId + '"]');
        if (thumbnailImage) {
            var thumbnailImages = document.querySelectorAll('.single-product-thumbnails .nav-item');
            thumbnailImages.forEach(function (thumbnailImage) {
                thumbnailImage.classList.remove('active-item');
            });
            thumbnailImage.classList.add('active-item');
            var slideIndex = parseInt(thumbnailImage.getAttribute('data-index') || "0");
            primarySplide.go(slideIndex - 1);
        }
    }
    handleFreeShippingBadge();
    var backInStockForm = document.querySelector(".single-product .focus-block .back-in-stock-form");
    var singleProduct = document.querySelector('.single-product');
    if (backInStockForm && singleProduct) {
        setupBackInStockForm(backInStockForm, singleProduct);
    }
}
function variantUrlSwitch() {
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("variant")) {
        var variantId = urlParams.get("variant");
        var variant = document.querySelector('.single-product .focus-block .variants button[id="' + variantId + '"]');
        if (variant) {
            handleVariantChange(variant);
        }
    }
}
variantUrlSwitch();
var variantSelectors = document.querySelectorAll('.single-product .focus-block .variants button');
if (variantSelectors && variantSelectors.length) {
    variantSelectors.forEach(function (variantSelector) {
        variantSelector.addEventListener('click', function () {
            handleVariantChange(variantSelector);
        });
    });
}
// Frequently bought together section
waitForElmSPP(".fbt-location .cbb-frequently-bought-container").then(function () {
    var _a, _b;
    // Calculate savings percentage
    var salesPrice = ((_a = document.querySelector('.fbt-location .cbb-frequently-bought-total-price-box .cbb-frequently-bought-total-price-sale-price')) === null || _a === void 0 ? void 0 : _a.textContent) || "";
    var regularPrice = ((_b = document.querySelector('.fbt-location .cbb-frequently-bought-total-price-box .cbb-frequently-bought-total-price-was-price')) === null || _b === void 0 ? void 0 : _b.textContent) || "";
    if (salesPrice && regularPrice) {
        var savingsAmount = calculateSavingsAmount(salesPrice, regularPrice);
        var priceBox = document.querySelector('.fbt-location .cbb-frequently-bought-total-price-box');
        var savingsText = "You save R " + savingsAmount;
        var savingsPercentageElement = document.createElement('div');
        savingsPercentageElement.classList.add('savings-amount');
        savingsPercentageElement.textContent = savingsText;
        priceBox === null || priceBox === void 0 ? void 0 : priceBox.appendChild(savingsPercentageElement);
    }
    // Add icons to add to cart button
    var addToCartButton = document.querySelector('.fbt-location .cbb-frequently-bought-add-button');
    if (addToCartButton) {
        var plus = document.createElement('img');
        plus.src = "https://cdn.shopify.com/s/files/1/0505/3071/3798/files/add-to-cart-plus.svg?v=1746035524";
        plus.loading = "lazy";
        plus.classList.add('plus');
        addToCartButton.append(plus);
    }
    // Grab the images and append them next to the product names
    var images = document.querySelectorAll('.fbt-location .cbb-frequently-bought-container .cbb-frequently-bought-products .cbb-frequently-bought-product');
    for (var index = 0; index < images.length; index++) {
        var imageWrapper = images[index];
        var image = imageWrapper.querySelector(".cbb-frequently-bought-product-image");
        if (image) {
            var imageSrc = getComputedStyle(image).backgroundImage.replace('url("', '').replace('")', '');
            if (imageSrc) {
                var productElement = document.querySelectorAll(".fbt-location .cbb-frequently-bought-selector-list li")[index];
                if (productElement) {
                    var children = productElement.querySelectorAll(":scope > *");
                    var contentWrapper = document.createElement('div');
                    contentWrapper.classList.add('content-wrapper');
                    for (var index_2 = 0; index_2 < children.length; index_2++) {
                        var child = children[index_2];
                        if (child) {
                            child.classList.add('move-me');
                            contentWrapper.append(child);
                        }
                    }
                    productElement.append(contentWrapper);
                    var title = productElement.querySelector("h3 span.cbb-frequently-bought-this-item-label");
                    var titleText = (title === null || title === void 0 ? void 0 : title.textContent) || "";
                    if (title && titleText) {
                        title.textContent = titleText.trim();
                    }
                    var imageWrapper_1 = document.createElement('div');
                    imageWrapper_1.classList.add("image-wrapper");
                    var imageElement = document.createElement('img');
                    imageElement.src = imageSrc;
                    imageElement.loading = "lazy";
                    imageElement.classList.add('product-image');
                    imageWrapper_1.append(imageElement);
                    productElement.prepend(imageWrapper_1);
                    var plusElement = document.createElement('img');
                    plusElement.src = "https://cdn.shopify.com/s/files/1/0505/3071/3798/files/plus-dark.svg?v=1725812033";
                    plusElement.loading = "lazy";
                    plusElement.classList.add('plus');
                    productElement.append(plusElement);
                }
            }
        }
    }
    var recommendationsContainer = document.querySelector('.fbt-location .cbb-frequently-bought-recommendations-container');
    recommendationsContainer === null || recommendationsContainer === void 0 ? void 0 : recommendationsContainer.classList.add('d-flex');
    var form = document.querySelector(".cbb-frequently-bought-form");
    var products = document.querySelector(".cbb-frequently-bought-selector-list");
    var wrapperDiv = document.createElement('div');
    wrapperDiv.classList.add('d-flex', 'flex-column', 'flex-md-row', 'w-100');
    form.before(wrapperDiv);
    wrapperDiv.appendChild(form);
    wrapperDiv.appendChild(products);
    products.classList.add('order-0', 'flex-1');
    form.classList.add('order-1', 'd-flex', 'flex-column', 'justify-content-between');
    // Add % off tag to top of price block
    var percentageOffWrapper = document.createElement('div');
    percentageOffWrapper.classList.add('percentage-off-wrapper');
    percentageOffWrapper.innerHTML = '<span class="percentage-off">Buy all 3 and receive<br> an extra <b>5% OFF</b></span>';
    form.prepend(percentageOffWrapper);
});
waitForElmSPP(".cbb-frequently-bought-add-button").then(function () {
    var frequentlyBoughtAddButton = document.querySelector(".cbb-frequently-bought-add-button");
    if (frequentlyBoughtAddButton) {
        frequentlyBoughtAddButton.addEventListener('click', function () {
            var imgs = frequentlyBoughtAddButton.querySelectorAll("img");
            for (var index = 0; index < imgs.length; index++) {
                var img = imgs[index];
                img.classList.add('d-none');
            }
            var checkAdded = setInterval(function () {
                var _a;
                var text = (_a = frequentlyBoughtAddButton.querySelector("span")) === null || _a === void 0 ? void 0 : _a.textContent;
                if (text === "Added!") {
                    clearInterval(checkAdded);
                    cart.update_cart();
                    cart.open_sticky_cart();
                    frequentlyBoughtAddButton.classList.add('green-bg', 'white-text');
                    setTimeout(function () {
                        var imgs = frequentlyBoughtAddButton.querySelectorAll("img");
                        for (var index = 0; index < imgs.length; index++) {
                            var img = imgs[index];
                            img.classList.remove('d-none');
                        }
                        frequentlyBoughtAddButton.classList.remove('green-bg', 'white-text');
                    }, 5000);
                }
            }, 10);
        });
    }
});
var tabs = null;
function handleDetailReviewsTabs() {
    var width = window.innerWidth;
    if (width >= 768) {
        if (tabs) {
            tabs.destroy();
            tabs = null;
        }
    }
    else if (!tabs) {
        // @ts-ignore
        tabs = new Tabby('[data-tabs]');
    }
}
document.addEventListener("DOMContentLoaded", function () {
    handleDetailReviewsTabs();
});
window.addEventListener("resize", function () {
    handleDetailReviewsTabs();
});
document.querySelectorAll(".product-tabs a").forEach(function (tab) {
    tab.addEventListener('click', function (event) {
        var width = window.innerWidth;
        if (width >= 786) {
            event.preventDefault();
        }
    });
});
waitForElmSPP(".jdgm-prev-badge").then(function () {
    var _a;
    (_a = document.querySelector(".jdgm-prev-badge")) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function (event) {
        event.stopPropagation();
        scrollToReviews();
    });
});
document.addEventListener("DOMContentLoaded", function (event) {
    if (window.location.hash === '#reviews') {
        event.preventDefault();
        setTimeout(function () {
            scrollToReviews();
        });
    }
});
function scrollToReviews() {
    var minus = 15;
    if (tabs) {
        tabs.toggle("#customer-reviews");
        minus = 60;
    }
    var header = document.querySelector('header');
    var reviews = document.querySelector('#customer-reviews');
    if (header && reviews) {
        var headerHeight = header.clientHeight;
        var offsetTop = reviews.getBoundingClientRect().top + window.scrollY - minus;
        window.scrollTo({
            top: offsetTop - headerHeight,
            behavior: "smooth"
        });
    }
}
waitForElmSPP(".jdgm-rev-widg__summary-inner").then(function () {
    var _a, _b, _c, _d;
    var averageRating = ((_a = document.querySelector(".jdgm-rev-widg")) === null || _a === void 0 ? void 0 : _a.getAttribute("data-average-rating")) || "0";
    if (parseInt(averageRating) > 0) {
        var averageRatingDiv = document.createElement('div');
        averageRatingDiv.classList.add('jdgm-average-rating');
        // Round to 1 decimal if a decimal exists
        if (averageRating.indexOf('.') != -1) {
            var roundedAverageRating = parseFloat(averageRating).toFixed(1);
            averageRatingDiv.textContent = roundedAverageRating;
        }
        else {
            averageRatingDiv.textContent = averageRating;
        }
        (_b = document.querySelector(".jdgm-rev-widg__summary-inner")) === null || _b === void 0 ? void 0 : _b.insertBefore(averageRatingDiv, document.querySelector(".jdgm-rev-widg__summary-inner").firstChild);
    }
    var reviewCount = ((_c = document.querySelector(".jdgm-rev-widg")) === null || _c === void 0 ? void 0 : _c.getAttribute("data-number-of-reviews")) || "0";
    if (parseInt(reviewCount) > 0) {
        var span = document.createElement('span');
        span.textContent = reviewCount;
        (_d = document.querySelector('a[href="#customer-reviews"]')) === null || _d === void 0 ? void 0 : _d.appendChild(span);
    }
});
(_b = document.querySelector(".jdgm-write-rev-link")) === null || _b === void 0 ? void 0 : _b.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    var reviewForm = document.querySelector(".jdgm-form-wrapper");
    if (reviewForm) {
        reviewForm.style.display = "block";
    }
});
// Shopify recommended products section
var handleIntersection = function (entries, observer) {
    if (!entries[0].isIntersecting)
        return;
    observer.unobserve(productRecommendationsSection);
    // @ts-ignore
    var url = productRecommendationsSection.dataset.url;
    fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var recommendations = html.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
            // Keep in line with product_grid.ts
            // @ts-ignore
            new Splide('.product-grid-splide', {
                perPage: 4,
                perMove: 1,
                type: 'loop',
                gap: "30px",
                padding: {
                    left: "0%",
                    right: "100px"
                },
                pagination: true,
                arrows: true,
                breakpoints: {
                    1199: {
                        perPage: 3,
                        gap: "15px",
                        padding: {
                            left: "0%",
                            right: "50px"
                        },
                    },
                    991: {
                        perPage: 2,
                        gap: "15px",
                        padding: {
                            left: "0%",
                            right: "50px"
                        },
                    },
                    480: {
                        perPage: 1,
                        gap: "15px",
                        padding: {
                            left: "0%",
                            right: "50px"
                        },
                    },
                },
            }).mount();
            setupAddToCartListeners();
            var productItems_1 = document.querySelectorAll('.product');
            // Keep in line with product_item.ts
            if (productItems_1 && productItems_1.length) {
                for (var index = 0; index < productItems_1.length; index++) {
                    var productItem = productItems_1[index];
                    if (productItem) {
                        calculateProductItemSavingsBadgePercentage(productItem);
                        calculateProductItemSavingsAmount(productItem);
                        setupVariantSelectorListeners(productItem);
                        // @ts-ignore
                        new Splide(productItem.querySelector('.product-item-thumbnails-splide'), {
                            perPage: 1,
                            perMove: 1,
                            type: 'slide',
                            gap: "0rem",
                            pagination: false,
                            arrows: false,
                            drag: false,
                            speed: 0,
                            waitForTransition: false,
                        }).mount();
                    }
                }
            }
        }
    })
        .catch(function (e) {
        console.error(e);
    });
};
var productRecommendationsSection = document.querySelector('.product-recommendations');
var observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 500px 0px' });
observer.observe(productRecommendationsSection);
if (window.innerWidth < 992) {
    waitForElmSPP('#smile-ui-lite-container').then(function () {
        var smileContainer = document.getElementById('smile-ui-lite-container');
        if (smileContainer) {
            smileContainer.classList.add('d-none');
        }
    });
}
function hideShopifyChatWidget(container) {
    container.classList.add('d-none');
    container.style.setProperty('display', 'none', 'important');
    container.style.setProperty('visibility', 'hidden', 'important');
    container.style.setProperty('pointer-events', 'none', 'important');
    container.setAttribute('hidden', '');
    container.setAttribute('aria-hidden', 'true');
}
if (document.body.classList.contains('template-product') &&
    window.matchMedia('(max-width: 767px)').matches) {
    ['shopify-chat', '#shopify-chat', '#ShopifyChat'].forEach(function (selector) {
        waitForElmSPP(selector).then(function (element) {
            if (element instanceof HTMLElement) {
                hideShopifyChatWidget(element);
            }
        });
    });
}
function handleSavingsDisplay(price, comparePrice) {
    var savingsTag = document.querySelector('.badges .badge.savings-badge span');
    if (savingsTag) {
        setSavingsBadge(savingsTag, price, comparePrice);
    }
    var comparePriceSpan = document.querySelector(".savings-amount span");
    if (comparePriceSpan) {
        setComparePriceSavingsAmount(comparePriceSpan, price, comparePrice);
    }
}
var initialPrice = ((_c = document.querySelector('.single-product')) === null || _c === void 0 ? void 0 : _c.getAttribute('data-price')) || "";
var initialComparePrice = ((_d = document.querySelector('.single-product')) === null || _d === void 0 ? void 0 : _d.getAttribute('data-compare-price')) || "";
if (initialPrice && initialComparePrice) {
    handleSavingsDisplay(initialPrice, initialComparePrice);
}
else {
    (_e = document.querySelector('.badges .badge.savings-badge')) === null || _e === void 0 ? void 0 : _e.classList.add('d-none');
}
var bundleUpsellButton = document.querySelector('.single-product .focus-block .bundle-upsell button');
bundleUpsellButton === null || bundleUpsellButton === void 0 ? void 0 : bundleUpsellButton.addEventListener('click', function () {
    var header = document.querySelector('header');
    var fbtWidget = document.querySelector('.fbt-location');
    if (header && fbtWidget) {
        var headerHeight = header.clientHeight;
        var offsetTop = fbtWidget.getBoundingClientRect().top + window.scrollY - 15;
        window.scrollTo({
            top: offsetTop - headerHeight,
            behavior: "smooth"
        });
    }
});
function preloadImages(urls) {
    for (var index = 0; index < urls.length; index++) {
        var URL_1 = urls[index];
        var img = new Image();
        img.src = URL_1;
    }
}
var imagesToPreload = [
    // Add to cart icons
    "https://cdn.shopify.com/s/files/1/0505/3071/3798/files/add-to-cart-plus.svg?v=1746035524",
    "https://cdn.shopify.com/s/files/1/0505/3071/3798/files/loading.svg?v=1712139921",
    "https://cdn.shopify.com/s/files/1/0505/3071/3798/files/tick.svg?v=1712479247",
    // Wishlist icons
    "https://cdn.shopify.com/s/files/1/0505/3071/3798/files/heart_2f210c84-dbe0-4782-8a9e-c6ebbfb11c19.svg?v=1747074983",
    "https://cdn.shopify.com/s/files/1/0505/3071/3798/files/wishlist-loading.svg?v=1747075180",
    "https://cdn.shopify.com/s/files/1/0505/3071/3798/files/wishlist-tick.svg?v=1747075180"
];
preloadImages(imagesToPreload);
function getActiveQuantitySelectorInput() {
    var width = window.innerWidth;
    var input = null;
    if (width >= 768) {
        input = document.querySelector('.single-product .focus-block .quantity-controller input');
    }
    else {
        input = document.querySelector('.single-product .floated-focus-block .quantity-controller input');
    }
    return input;
}
